import React, { useEffect, useState } from "react"
import moment from "moment"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import Input from "@/components/core/Input/Input"
import Autocomplete from "@/components/core/Autocomplete/Autocomplete"
import ImageUpload from "@/components/RegisterOfflineProduct/v1/ImageUpload"
import { getRemoveOfflineProductsAnalytics } from "@/components/RegisterOfflineProduct/v1/RegisterOfflineHelper"
import calendarIcon from "@/public/icons/calendar.svg"
import styles from "@/components/RegisterOfflineProduct/v1/ProductForm/index.module.scss"
import { getDealerNames } from "@/utils/findStore"

const ProductForm = ({
  id = "",
  data = {},
  title = "",
  staticText = {},
  suggestions = [],
  dealersDetail = [],
  handleData = () => {},
  removeForm = () => {},
  setCurrentForm = () => {},
  clearSuggestions = () => {},
}) => {
  const [dealerNames, setDealerNames] = useState([])
  const getDealerFunction = async () => {
    const response = await getDealerNames()
    let totalRecords = response?.result.totalRecords
    const res = await getDealerNames(totalRecords)
    let dealers =
      res?.result.data.stores.map(dealer => ({
        name: dealer.storeName,
      })) ?? []
    setDealerNames(dealers)
  }
  useEffect(() => {
    getDealerFunction()
  }, [])
  const handleProductDetails = e => {
    handleData({
      ...data,
      productDetails: { value: e.target.value, error: false, message: "" },
    })
    if (e.target.value.length > 2) {
      setCurrentForm(id)
    } else {
      Boolean(suggestions.length) && clearSuggestions()
    }
  }

  const changeDateFormat = date => {
    if (date) {
      const dateVal = moment(date).format("MM/DD/YYYY")
      handleData({
        ...data,
        dateOfPurchase: { value: dateVal, error: false, message: "" },
      })
    } else {
      handleData({
        ...data,
        dateOfPurchase: { value: "", error: false, message: "" },
      })
    }
  }

  const handleValidation = async field => {
    if (field === "product") {
      if (!data?.productDetails?.value) {
        handleData({
          ...data,
          productDetails: {
            ...data?.productDetails,
            error: true,
            message: staticText.productError,
          },
        })
      }
    }

    if (field === "dateOfPurchase") {
      if (!data?.dateOfPurchase?.value) {
        handleData({
          ...data,
          dateOfPurchase: {
            ...data?.dateOfPurchase,
            error: true,
            message: staticText.dateOfPurchaseError,
          },
        })
      }
    }
  }

  // const dataList =
  //   dealersDetail.map(dealer => {
  //     return { name: dealer.value }
  //   })

  return (
    <div className={`${styles.productFormWrapper}`}>
      <div className="product-form">
        <div className="product-from-container">
          <div className="form-section">
            <div className="text-box-row">
              <Input
                id={`modelNumber-${id}`}
                type="text"
                value={data?.productDetails?.value}
                maxLength={250}
                placeholder={`${staticText.productDetails}`}
                label={`${staticText.productDetails}`}
                showError={data?.productDetails?.error}
                errorMessage={data?.productDetails?.message}
                onInput={e => handleProductDetails(e)}
                onChange={e => handleProductDetails(e)}
                onBlur={() => handleValidation("product")}
                ariaLabel={title}
              />
            </div>

            <div className="text-box-row">
              <Input
                id={`serialNumber-${id}`}
                type="text"
                value={data?.serialNumber?.value}
                maxLength={40}
                placeholder={`${staticText.serialNumber}`}
                label={`${staticText.serialNumber}`}
                showError={data?.serialNumber?.error}
                errorMessage={data?.serialNumber?.message}
                onInput={e =>
                  handleData({
                    ...data,
                    serialNumber: {
                      value: e.target.value,
                      error: false,
                      message: "",
                    },
                  })
                }
                onChange={e =>
                  handleData({
                    ...data,
                    serialNumber: {
                      value: e.target.value,
                      error: false,
                      message: "",
                    },
                  })
                }
              />
            </div>
            <div className="text-box-row">
              <Autocomplete
                id={`product-registeration-dealer-name-${id}`}
                onInput={val =>
                  handleData({
                    ...data,
                    dealerName: { value: val, error: false, message: "" },
                  })
                }
                onChange={val =>
                  handleData({
                    ...data,
                    dealerName: { value: val, error: false, message: "" },
                  })
                }
                value={data?.dealerName?.value}
                data={dealerNames}
                label={`${staticText.dealerName}`}
              />
            </div>
            <div className="kf-react-datepicker">
              <DatePicker
                selected={Date.parse(data.dateOfPurchase.value)}
                dateFormat="dd/MM/yyyy"
                customInput={
                  <Input
                    id={id}
                    prefix={<img src={calendarIcon.src} alt="calendar-icon" />}
                    placeholder={`${staticText.datePurchase}`}
                    label={`${staticText.datePurchase}`}
                    showError={data?.dateOfPurchase?.error}
                    errorMessage={data?.dateOfPurchase?.message}
                  />
                }
                id={`installationDate-${id}`}
                onInput={date => changeDateFormat(date)}
                onChange={date => changeDateFormat(date)}
                minDate={new Date("01/01/2001")}
                maxDate={new Date()}
                isClearable={!!Date.parse(data?.dateOfPurchase?.value)}
                onBlur={() => handleValidation("dateOfPurchase")}
              />
            </div>
          </div>
          <div className="image-upload-section">
            <ImageUpload
              uploadButtonAnalytics={`{"eventAction":"my account:register non kohler products:product information:upload photos","eventName":"my account:register non kohler products:product information:upload photos","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"upload photos","internalLinkPosition":"register products","internalLinkType":"my account:navigation","internalLinkZoneName":"my account:register non kohler products:product information","internalLinkURL":"n/a","clickInternalLinks":"true"}`}
              data={data}
              staticText={staticText}
              handleData={handleData}
            />
          </div>
        </div>
        {id !== 0 && (
          <a
            role="button"
            className="remove-link gbh-data-layer"
            data-gbh-data-layer={getRemoveOfflineProductsAnalytics()}
            onClick={removeForm}
          >
            {staticText.remove}
          </a>
        )}
      </div>
    </div>
  )
}

export default ProductForm
